import { render, staticRenderFns } from "./createSettlement.vue?vue&type=template&id=06f2c983&scoped=true&"
import script from "./createSettlement.vue?vue&type=script&lang=js&"
export * from "./createSettlement.vue?vue&type=script&lang=js&"
import style0 from "./createSettlement.vue?vue&type=style&index=0&id=06f2c983&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f2c983",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f2c983')) {
      api.createRecord('06f2c983', component.options)
    } else {
      api.reload('06f2c983', component.options)
    }
    module.hot.accept("./createSettlement.vue?vue&type=template&id=06f2c983&scoped=true&", function () {
      api.rerender('06f2c983', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/paySettlement/createSettlement.vue"
export default component.exports